function DoneStep({ eodId, onRestart }) {
  return (
    <div className="menzies-wizard">
      <h2 >Step 4: Done</h2>
      <p>✅ Barcodes have been successfully sent</p>
      <button className="btn"  onClick={onRestart}>Return to start</button>
    </div>
  );
}
export default DoneStep